$shm_hitalama_map_book_page $mol_view
	map_id \
